import {useCallback} from 'react';
import {Concept} from 'types';
import type {Filter, ViewMode} from 'services/advancedSearch/types';
import {useLazyPostInfoQuery} from 'services/advancedSearch/advancedSearchApi';
import {mapPostInfoApiArgs} from 'services/advancedSearch/mappers/mapPostInfoApiArgs';
import {mapDataToMetadataId} from '../mappers';

export const useGetMetadataIds = () => {
  const [postInfo] = useLazyPostInfoQuery();

  return useCallback(
    (
      viewMode: ViewMode,
      filters: Filter[],
      sort?: string,
      page: number = 0,
      size: number = 200,
    ) => {
      const apiArgs = mapPostInfoApiArgs(
        {
          type: viewMode,
          filters,
          columns: viewMode === Concept.work ? ['workId'] : ['workId', 'ean'],
          page,
          size,
          sort,
        },
        [
          {
            name: 'workId',
            type: 'TEXT',
            workColumn: true,
          },
          {
            name: 'ean',
            type: 'TEXT',
            workColumn: false,
          },
        ],
      );

      if (!apiArgs) {
        return Promise.resolve([]);
      }

      return postInfo(apiArgs)
        .unwrap()
        .then(r => (r?.rows ?? []).map(mapDataToMetadataId));
    },
    [postInfo],
  );
};
